import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AlertType, AlertInfoTrigger } from 'src/app/core/Models/interfaces/alert&toast';
import { ToasterService } from '../../services/toaster.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-message-pop-up',
  templateUrl: './message-pop-up.component.html',
  styleUrls: ['./message-pop-up.component.css']
})
export class MessagePopUpComponent implements OnInit {

  public showAlert: boolean = false;
  private resolve: any;
  public title: string = '';
  public text: string = '';
  public type: AlertType = 'success';
  public hideCancelButton: boolean = false;
  public hideOkButton: boolean = false;
  public okText: string = 'Ok';
  public cancelText: string = 'Cancel';
  public additionalButton : any;
  public iconMap = {
    'success': 'success',
    'error': 'err',
    'warning': 'warning',
    'info': 'info',
    'warning-icon' : 'warning-icon'
  }
  public isTitleCash: boolean | undefined = false;

  @ViewChild('titleFoc') titleFoc!: ElementRef;
  @ViewChild('close') close!: ElementRef;
  hideCloseIcon: boolean = false;
  @ViewChild('okFoc') okFoc!:ElementRef

  constructor(
    private toasterService : ToasterService,
    private router: Router,
  ) { }

  @HostListener('keydown', ['$event'])
  clickarrowx(event: any) {
    if(event.target.id === "success" && (event.code === 'Tab' || event.key === 'Tab') ){
      this.close?.nativeElement.focus();
      event.preventDefault();
    }
    if(event.code === 'Escape' || event.key === 'Escape'){
      this.confirm(false);
    }
  }


  ngOnInit(): void {
    this.toasterService.alertTrigger$.subscribe(({ type, title, text, okText, cancelText, hideCancelButton, hideOkButton, resolve, isTitleCash,hideCloseIcon, addditionalButton}: AlertInfoTrigger) => {
      this.showAlert = true;
      this.resolve = resolve;
      this.type = type;
      this.title = title;
      this.text = text;
      this.okText = okText || 'Ok';
      this.cancelText = cancelText || 'Cancel';
      this.hideCancelButton = hideCancelButton || false;
      this.hideOkButton = hideOkButton || false;
      this.isTitleCash = isTitleCash;
      this.additionalButton = addditionalButton;
      this.hideCloseIcon = hideCloseIcon || false;
      setTimeout(()=> {
        this.titleFoc?.nativeElement.focus();
        if( this.hideCancelButton && !this.hideOkButton){
          this.okFoc?.nativeElement.focus();
        }
      });
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if(this.showAlert ){
          this.confirm(false);
        }
      }
    })
  }

  confirm(status: boolean) {
    this.resolve(status);
    this.showAlert = false;
  }
  
  confirmAdditionalBtn(){
    this.additionalButton.actionFunction();
    this.showAlert = false;
  }

}
